import { api, setConfig } from '../..';
import { mapEntityToApi, mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';
import axios from 'axios';

let cancelToken: any;

export const getPartnersReports = (data: PropertyType): Promise<PropertyType> => {
	if (cancelToken !== undefined) {
		cancelToken.cancel('cancelled');
	}
	cancelToken = axios.CancelToken.source();
	const headers = setConfig(data);
	return api
		.post(`reports/gambling-report${data?.query}`, mapEntityToApi(data), {
			...headers,
			cancelToken: cancelToken.token,
		})
		.then((res) => {
			return mapApiToEntity(res.data);
		});
};
